module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./ReportView.js"));
	}, "taskManageView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=taskManageView!./src/pages/DispatchCenter/Report/ReportView.js
// module id = ./node_modules/bundle-loader/index.js?lazy&name=taskManageView!./src/pages/DispatchCenter/Report/ReportView.js
// module chunks = 43